import React from "react";
import { InputBaseProps } from "..";
import { SanityInputDatetimeProps } from "../../../models/form/SanityFormInputField";
import GenericTextInput from "./GenericTextInput";

export type DatetimePickerProps = InputBaseProps<SanityInputDatetimeProps>;

const DatetimePicker = (props: DatetimePickerProps) => (
  <GenericTextInput {...props} type="datetime-local" />
);

export default DatetimePicker;
